import { render, staticRenderFns } from "./user-diamond.vue?vue&type=template&id=37526904&scoped=true&"
import script from "./user-diamond.vue?vue&type=script&lang=js&"
export * from "./user-diamond.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37526904",
  null
  
)

export default component.exports